export const GeometryTypes = {
    POINT: "Point",
    POLYGON: "Polygon",
    CIRCLE: "Circle",
    LINE: "LineString",
    COLLECTION: "GeometryCollection",
};
